import { Field } from "typegraph";
import { ID } from "common/entities/IEntity";
import Tag from "./Tag";

export default class Product {

	@Field()
	public id: ID;

	@Field()
	public name: string;

	@Field()
	public subTitle: string;

	@Field()
	public iconURL: string;

	@Field()
	public shortDescription: string;

	@Field()
	public description: string;

	@Field()
	public displayStartDate: string;

	@Field()
	public displayEndDate: string;

	@Field({entity: Tag})
	public tags?: null | Tag[];
}


// WEBPACK FOOTER //
// ./src/panels/catalog/entities/Product.ts